import React from "react";
import { fetchAbandonedCarts, updateAbandonedCartLeadInfo, fetchCustomTimeAbandonedCart } from "../../../actions/customers";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
import { Loader } from "../../../components/loader";
import { NotificationManager } from "react-notifications";
import BootstrapTable from "react-bootstrap-table-next";
import paginationFactory from "react-bootstrap-table2-paginator";
import "react-bootstrap-table-next/dist/react-bootstrap-table2.min.css";
import "react-bootstrap-table2-paginator/dist/react-bootstrap-table2-paginator.min.css";
import { DateRangePicker, SingleDatePicker, DayPickerRangeController } from 'react-dates';
import filterFactory, {
  textFilter,
  selectFilter
} from "react-bootstrap-table2-filter";
import ToolkitProvider, { Search } from "react-bootstrap-table2-toolkit";
import "react-bootstrap-table-next/dist/react-bootstrap-table2.min.css";
import classnames from "classnames";
import { BreadCrumb } from "../../../components/breadcrumb";
import MessageToAbandonCustomers from "../../../components/dataModal/messagetoAbandonCustomers";
import {convertToTitleCase} from "../../../utils/helper"
import moment from "moment";
import Responsive from "react-responsive";
import { NavLink } from "react-router-dom";

const $ = window.$;
const { SearchBar } = Search;
const toCapitalize = (name) => {
  if (name && name.length > 1) {
    return name.charAt(0).toUpperCase() + name.slice(1).toLowerCase();
  }
};
const orientation = window.matchMedia("(max-width: 700px)").matches ? 'vertical' : 'horizontal'

class CenteredTabs extends React.Component {
  constructor(props) {
    super(props);
  }
  state = {
    abandonedCartData : [],
    loading : true,
    selectedTab: "AbandonedCart",
    customTimeAbandonedCarts : [],
    loadingCustomAbandonedCart: false,
  };



  tableHeaderTopColumnData= [
    {
      dataField: "petId",
      text: "Pet ID",
      sort: true,
      formatter: (cell,row) => {
        return(
          <span className="m-topbar__userpic">
          {row && row.avatar_path ? (
            <img
              src={
                process.env.REACT_APP_S3_PATH +
                "/" +
                row.avatar_path +
                "/" +
                row.avatar_file_name
              }
              className="m--img-rounded m-width-50 mr-2"
              alt=""
            />
          ):null 
            }
          {row.petId ? (
          <a
            href={ `${process.env.REACT_APP_API_ENDPOINT}/core/medicalrecord/pdf/${this.props.data.petShopReducer.currentPetshop.id}/${row.medicalRecordId}`}
            target="_blank"  
            style={{ color:"#ffff"}}      
           >
            <span className="m-badge m-badge--info mx-auto my-0 px-2">
              <strong>{row.petId}</strong>
            </span>
           </a>     
          ) : ( 
            <span className="m--font-boldest">(Does Not Exist)</span>        
          )}
        </span>
        )
      }
    }
  ];

  tableHeaderAbandonedColumnData = [
    {
      dataField: 'firstname', text: 'First Name', sort: true,
    },
    {
      dataField: 'lastname', text: 'Last Name', sort: true,
    },
    {
      dataField: 'email_address',
      text: 'Email',
      sort: true,
      formatter: (cell, row) => <a href={`mailto:${cell}?body=Hello, ${convertToTitleCase(row.firstname)}!`} className="hyperlink">{cell}</a>

    },
    {
      dataField: 'phone_number',
      text: 'Phone',
      sort: true,
      formatter: cell => <a href={`tel:${cell}`} className="hyperlink-phone-number">{cell}</a>
    },
    {
      dataField: 'lead_source',
      text: 'Lead Source',
    },
    {
      dataField: 'createdAt',
      text: 'Submitted Date',
      sort: true,   
    },
    {
      dataField: 'isSubscribed',
      text: 'Subscribed',
      sort: true,
      formatter: (cell, row) => {
        return (       
               cell == true ?  
                <span className="m-badge mx-auto my-0 px-2 m-badge--success">       
                  <strong>Yes</strong>                   
                </span>:
                <span className="m-badge mx-auto my-0 px-2 m-badge--danger">
                 <strong> No</strong> 
                </span>               
              );
      }
    }, 
    {
      dataField: 'notes',
      text: 'Notes',
      sort: true,
      formatter: (cell, row) => {
        return ( 
        <div>
          <a
           href=""
           onClick={(e) => {this.openNotesEditModal(e,row)}}
           style ={{ color : "#575962" }}
          > 
             {cell}
             <i className="la la-edit"></i>
          </a>
        </div>
        );
      }
    },
  ];

  tableHeaderCustomAbandonedCartColumnData = [
    {
      dataField: "petId",
      text: "Pet ID",
      sort: true,
      formatter: (cell,row) => {
        return(
          <span className="m-topbar__userpic">
          {row && row.avatar_path ? (
            <img
              src={
                process.env.REACT_APP_S3_PATH +
                "/" +
                row.avatar_path +
                "/" +
                row.avatar_file_name
              }
              className="m--img-rounded m-width-50 mr-2"
              alt=""
            />
          ):null 
            }
          {row.petId ? (
          <a
            href={ `${process.env.REACT_APP_API_ENDPOINT}/core/medicalrecord/pdf/${this.props.data.petShopReducer.currentPetshop.id}/${row.medicalRecordId}`}
            target="_blank"  
            style={{ color:"#ffff"}}      
           >
            <span className="m-badge m-badge--info mx-auto my-0 px-2">
              <strong>{row.petId}</strong>
            </span>
           </a>     
          ) : ( 
            <span className="m--font-boldest">(Does Not Exist)</span>        
          )}
        </span>
        )
      }
    },
    {
      dataField: 'firstname', text: 'First Name', sort: true,
    },
    {
      dataField: 'lastname', text: 'Last Name', sort: true,
    },
    {
      dataField: 'email_address',
      text: 'Email',
      sort: true,
      formatter: (cell, row) => <a href={`mailto:${cell}?body=Hello, ${convertToTitleCase(row.firstname)}!`} className="hyperlink">{cell}</a>
    },
    {
      dataField: 'phone_number',
      text: 'Phone',
      sort: true,
      formatter: cell => <a href={`tel:${cell}`} className="hyperlink-phone-number">{cell}</a>
    },
    {
      dataField: 'lead_source',
      text: 'Lead Source',
    },
    {
      dataField: 'pet_id', text: 'UTM Source / ID / Campaign / Medium', sort: true, formatter: (cell, row) => {
        return (
        ( row.utmData && row.utmData.length > 0 ?  
         <>       
          <span className="m-badge my-0 px-2 m-badge--warning">               
          <strong>{row.utmData[0] && row.utmData[0].utm_source} </strong>           
          </span><br/>
          <span className="m-badge mt-1 px-2 m-badge--success"> { row.utmData[0] && row.utmData[0].utm_id} </span><br/>
          <span className="m-badge mt-1 px-2 m-badge--primary"> { row.utmData[0] && row.utmData[0].utm_campaign} </span><br/>
          <span className="m-badge mt-1 px-2 m-badge--accent"> { row.utmData[0] && row.utmData[0].utm_medium} </span>
         </>:
         <span>No Utm <br/> Source</span>
        )       
        )
      }
    },
    {
      dataField: 'createdAt',
      text: 'Submitted Date',
      sort: true,   
      formatter: cell => moment(cell).format('MM-DD-YYYY'), sort: true, 
    },
    {
      dataField: 'isSubscribed',
      text: 'Subscribed',
      sort: true,
      formatter: (cell, row) => {
        return (       
               cell == true ?  
                <span className="m-badge mx-auto my-0 px-2 m-badge--success">       
                  <strong>Yes</strong>                   
                </span>:
                <span className="m-badge mx-auto my-0 px-2 m-badge--danger">
                 <strong> No</strong> 
                </span>               
              );
      }
    }, 
    {
      dataField: 'notes',
      text: 'Notes',
      sort: true,
      formatter: (cell, row) => {
        return ( 
        <div>
          <a
           href=""
           onClick={(e) => {this.openNotesEditModal(e,row)}}
           style ={{ color : "#575962" }}
          > 
             {cell}
             <i className="la la-edit"></i>
          </a>
        </div>
        );
      }
    },
  ];




  expandRow = {
    renderer: (row, rowIndex) => (  
      <div>            
        <ToolkitProvider
          keyField="id"
          data={ row.rows }
          columns={this.tableHeaderAbandonedColumnData}
          search
          hover={true}
          filter={filterFactory()}                       
        >
        {props => (
          <div>                                              
            <BootstrapTable  
             classes="breedersPuppyChildTable"                          
             {...props.baseProps}                       
            />  
           </div>                    
        )}
       </ToolkitProvider>  
      </div>
   ),
     showExpandColumn: true ,
     expandHeaderColumnRenderer: ({ isAnyExpands }) => {
             if (isAnyExpands) {
             return <b style={{cursor: 'pointer'}}><i className="fas fa-chevron-circle-up"></i></b>;
             }
             return <b style={{cursor: 'pointer'}}><i className="fas fa-chevron-circle-down"></i></b>;
           },
     expandColumnRenderer: ({ expanded }) => {
             if (expanded) {
               return (
                 <div style={{cursor: 'pointer', marginTop: '0px'}}><i className="fas fa-chevron-circle-up"></i></div>
               );
             }
             return (
               <div style={{cursor: 'pointer', marginTop: '0px'}}><i className="fas fa-chevron-circle-down"></i></div>
             );
           }
  };


  componentDidMount() {  
    this.props.fetchAbandonedCarts();
  
  }

  componentWillReceiveProps = nextProps => {   

    if(nextProps.abandonedCarts !== this.props.abandonedCarts){     
        this.setState({ abandonedCartData : nextProps.abandonedCarts, loading : false});
    }

    if (nextProps.abandonedCartsError !== this.props.abandonedCartsError) {
      NotificationManager.error('Failed to load abandoned cart.');
      this.setState({ loading : false });
    }

    
    if(nextProps.updatedAbandonedCartLead && this.props.updatedAbandonedCartLead !== nextProps.updatedAbandonedCartLead){
      $("#notes-edit-modal").modal("hide");     
      this.props.fetchAbandonedCarts(); 
      NotificationManager.success("Abandoned Cart record updated successfully.");
    }
    
    if(nextProps.customTimeAbandonedCart !== this.props.customTimeAbandonedCart){   
      this.setState({ customTimeAbandonedCarts : nextProps.customTimeAbandonedCart, loadingCustomAbandonedCart : false });
      $("#calender_open_modal").modal("hide");    
    }

    if (nextProps.customTimeAbandonedCartError !== this.props.customTimeAbandonedCartError) {
      NotificationManager.error('An error occurred while loading the abandoned carts');
      this.setState({ loadingCustomAbandonedCart : false });
     }
 

  };

  openMessageAbandonCustomers(e){
    this.setState({messageSubscribers: true})
    $('#message-to-abandon-customers').modal('show');
  }

  openNotesEditModal = (e,row) => {
    e.preventDefault();
    let notes = row.notes ? row.notes : "";
    this.setState({ abandonedCartId : row.id, abandonedCartNotes : notes });
    $("#notes-edit-modal").modal("show"); 
  }

  submitNotes = () => {
      let abandonedCartId = this.state.abandonedCartId;
      let data = {
        notes : this.state.abandonedCartNotes
      }
     this.props.updateAbandonedCartLeadInfo(abandonedCartId,data);
  }

  
  changeVal = event => {
    let value = event.target.value;
    this.setState({
      ...this.state,
      [event.target.name]: value
    });
  };

  changeTab = (tabName) => {
    this.setState({ selectedTab:tabName }); 
  }  

  changeCustomTimeTab = (tabName) => {
    let sdate = moment().subtract(7,'days');
    let edate = moment();
    const startDate = moment(sdate).format("YYYY-MM-DD");
    const endDate = moment(edate).format("YYYY-MM-DD");
    this.setState({ selectedTab:tabName, sDate : sdate, eDate : edate }); 
    this.props.fetchCustomTimeAbandonedCart(startDate,endDate);
  }

  
  openCollerInsertModal(e) {
    e.preventDefault();
    let sdate = moment().subtract(7,'days');
    let edate = moment();
    this.setState({ sDate: sdate, eDate: edate });
    $("#calender_open_modal").modal("show");
  }

  submitCustomAbandonedCart(e){
    e.preventDefault();
    const startDate = moment(this.state.sDate).format('YYYY-MM-DD');
    const endDate = moment(this.state.eDate).format('YYYY-MM-DD');
    this.setState({ loadingCustomAbandonedCart : true });
    this.props.fetchCustomTimeAbandonedCart(startDate,endDate);
  }
 
  items = [{ title: "Breeders", to: "/breeders" }];

  render() {
   
    const {   
      abandonedCartData,
      abandonedCartNotes,
      selectedTab,
      customTimeAbandonedCarts,
    } = this.state;

    return (
      <div className="m-grid m-grid--hor m-grid--root m-page">
        <div className="m-grid__item m-grid__item--fluid m-grid m-grid--hor-desktop m-grid--desktop m-body body-background">    
          <div className="m-grid__item m-grid__item--fluid  m-grid m-grid--ver	m-container m-container--responsive m-container--xxl m-page__container">
            <div className="m-grid__item m-grid__item--fluid m-wrapper">
              <div className="m-portlet m-portlet--mobile">
                <div className="m-portlet__head medical-record-head-btn-set" >
                  <div className="m-portlet__head-caption">
                    <div className="m-portlet__head-title">
                      <h3 className="m-portlet__head-text">
                        Abandoned Cart                   
                      </h3>
                    </div>
                  </div>
                  <div className="notification-manager-button-container">   
                   { selectedTab == "CustomTimeAbandonedCart" &&
                    <div className="m-portlet__head-tools notification-refresh-btn">
                    <div
                        className="btn m-btn--pill btn-outline-accent m-btn m-btn--custom m-btn--outline-2x"
                        onClick={(e) => this.openCollerInsertModal(e)}
                      >
                        <span>
                          <i className="las la-calendar"></i>
                          <span>Select Date Range</span>
                        </span>
                      </div>

                    </div>
                    }
                    <div className="m-portlet__head-tools notification-send-btn">
                        <button
                            className="m-nav__link btn btn-accent m-btn m-btn--custom m-btn--icon m-btn--air m-btn--pill"
                            onClick={(e) => this.openMessageAbandonCustomers(e)}
                        >
                            <span>
                              <i class="las la-percentage"></i>
                              <span>Message Customers</span>
                            </span>
                        </button>
                    </div>
                    
                  </div>               
                </div>
                <div className="m-portlet__body medical-record-content">  
                    <ul
                    className="nav nav-pills nav-pills--success m-nav-pills--btn-pill m-nav-pills--btn"
                    role="tablist"
                  >
                    <li className="nav-item m-tabs__item">
                      <button
                        className={classnames({
                          "nav-link m-tabs__link pl-4 pr-4 btn m-btn--pill btn-secondary m-btn m-btn--custom m-border-color-none": true,
                          active: selectedTab === "AbandonedCart",
                        })}                  
                        onClick={() => this.changeTab("AbandonedCart") }
                      >
                        Abandoned Cart ({abandonedCartData && abandonedCartData.length ? abandonedCartData.length : 0 })
                      </button>
                    </li>
                    <li className="nav-item m-tabs__item">
                      <button
                        className={classnames({
                          "nav-link m-tabs__link pl-4 pr-4 btn m-btn--pill btn-secondary m-btn m-btn--custom m-border-color-none": true,
                          active: selectedTab === "CustomTimeAbandonedCart",
                        })}                  
                         onClick={() => this.changeCustomTimeTab("CustomTimeAbandonedCart") }
                      >
                        Filtering By Date ({customTimeAbandonedCarts && customTimeAbandonedCarts.length ? customTimeAbandonedCarts.length : 0 })
                      </button>
                    </li>       
                  </ul> 
                  { selectedTab == "AbandonedCart" &&
                  <>
                  {this.state.loading ?
                  <div className="center-row">
                      <Loader size={50}/>
                  </div>
                   :<ToolkitProvider
                      keyField="id"
                      data={ abandonedCartData }
                      columns={this.tableHeaderTopColumnData}
                      search
                      hover={true}
                      filter={filterFactory()}
                    >
                      {props => (
                        <div>
                          <div className="px-0 mb-4 search-bar">
                            <div className="col-lg-3 px-0 inner-addon right-addon">
                              <i className="fas fa-search"></i>
                              <SearchBar {...props.searchProps} />
                            </div>
                          </div>                 
                            <BootstrapTable
                              classes="petTable"
                              {...props.baseProps}
                              pagination={paginationFactory()}
                              expandRow={ this.expandRow } 
                            />                        
                        </div>
                      )}
                    </ToolkitProvider>  
                   }   
                 
                 </>
                   }
                { selectedTab == "CustomTimeAbandonedCart" &&
                  <>
                  {this.state.loadingCustomAbandonedCart ?
                  <div className="center-row">
                      <Loader size={50}/>
                  </div>
                   :<ToolkitProvider
                      keyField="id"
                      data={ customTimeAbandonedCarts }
                      columns={this.tableHeaderCustomAbandonedCartColumnData}
                      search
                      hover={true}
                      filter={filterFactory()}
                    >
                      {props => (
                        <div>
                          <div className="px-0 mb-4 search-bar">
                            <div className="col-lg-3 px-0 inner-addon right-addon">
                              <i className="fas fa-search"></i>
                              <SearchBar {...props.searchProps} />
                            </div>
                          </div>                 
                            <BootstrapTable
                              classes="petTable"
                              {...props.baseProps}
                              pagination={paginationFactory()}                             
                            />                        
                        </div>
                      )}
                    </ToolkitProvider>  
                   }   
                 
                 </>
                   }
                </div>
              </div> 
            </div>
              {/* Abandoned cart notes edit stat */}
              <div className="modal fade show" id="notes-edit-modal" tabIndex="-1" role="dialog">
                <div className="modal-dialog" role="document">
                    <div className="modal-content">
                      <div className="modal-header">
                        <h5 className="modal-title" id="exampleModalLabel">Edit Notes</h5>
                        <button type="button" className="close" data-dismiss="modal" aria-label="Close">
                          <span aria-hidden="true">&times;</span>
                        </button>
                      </div>
                      <div className="modal-body">
                        <div className="form-group m-form__group">
                          <label for="exampleTextarea">Notes</label>
                          <textarea 
                            className="form-control m-input m-input--air" 
                            id="abandonedCartNotes"
                            rows="3"                
                            name="abandonedCartNotes"
                            onChange={this.changeVal}   
                            placeholder=""
                            value={abandonedCartNotes}                    
                          >
                          </textarea>
                        </div>
                      </div>
                      <div className="modal-footer">              
                        <div>
                          <button type="button" className="btn btn-secondary m-btn--pill mx-2" data-dismiss="modal">Cancel</button>
                          <button type="button" onClick={() => this.submitNotes()} className="btn btn-primary m-btn--pill">Submit</button>
                        </div>                   
                      </div>
                    </div>
                </div>
              </div>
              {/* Abandoned cart notes edit end */}
              <div
                className="modal fade"
                id="calender_open_modal"
                tabIndex="-1"
                role="dialog"
                aria-labelledby="ConfirmationModalLabel"
                aria-hidden="true"
              >
                <div className="modal-dialog" role="document">
                  <div className="modal-content">
                    <div className="modal-header">
                      <h5 className="modal-title" id="exampleModalLabel">
                       Select Date Range
                      </h5>
                      <button
                        type="button"
                        className="close"
                        data-dismiss="modal"
                        aria-label="Close"
                      >
                        <span aria-hidden="true">&times;</span>
                      </button>
                    </div>
                    <div className="modal-body">
                      <div>
                        <div style={{ textAlign: "center" }}>
                          <div>
                            <Mobile>
                              <DateRangePicker
                                startDateId="startDate1"
                                endDateId="endDate1"
                                startDate={this.state.sDate}
                                endDate={this.state.eDate}
                                onDatesChange={({ startDate, endDate }) => {
                                  this.setState({ sDate: startDate, eDate: endDate });
                                }}
                                focusedInput={this.state.focusedInputCI}
                                onFocusChange={focusedInput => {
                                  this.setState({ focusedInputCI: focusedInput });
                                }}
                                orientation={orientation}
                                isOutsideRange={() => false}
                              />
                            </Mobile>
                            <Default>
                              <DateRangePicker
                                startDateId="startDate1"
                                endDateId="endDate1"
                                startDate={this.state.sDate}
                                endDate={this.state.eDate}
                                onDatesChange={({ startDate, endDate }) => {
                                  this.setState({ sDate: startDate, eDate: endDate });
                                }}
                                focusedInput={this.state.focusedInputCI}
                                onFocusChange={focusedInput => {
                                  this.setState({ focusedInputCI: focusedInput });
                                }}
                                orientation={orientation}
                                isOutsideRange={() => false}
                              />
                            </Default>

                            {/* <div className="form-group m-form__group row">
                              <div style={{width: "60%", margin: "0 auto", marginTop: "15px"}}>
                                <Select
                                  options={breeders}
                                  value={BreederId}
                                  name="BreederId"
                                  onChange={this.changeBreeder}
                                  placeholder="Select The Breeder"
                                />
                              </div>
                            </div> */}

                          </div>  

                          <div style={{ width: "100%", marginTop: "21px" }}>                
                            <button
                              type="button"
                              className="btn btn-primary m-btn--pill mx-2"
                              onClick={(e) => this.submitCustomAbandonedCart(e)}
                            >
                              Submit
                            </button>                      
                          </div>

                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            <MessageToAbandonCustomers openClose={this.state.messageSubscribers} />
          </div>
        </div>  
     
      </div>
    );
  }
}

const mapStateToProps = state => ({
  abandonedCarts : state.customersReducer.abandonedCartsList,
  customTimeAbandonedCart : state.customersReducer.customTimeAbandonedCart,
  customTimeAbandonedCartError : state.customersReducer.customTimeAbandonedCartError,
  abandonedCartsError : state.customersReducer.abandonedCartsError,
  updatedAbandonedCartLead : state.customersReducer.updatedAbandonedCartLead,
  data: state,

  
});

export const Mobile = (props) => <Responsive {...props} maxWidth={767} />;
export const Default = (props) => <Responsive {...props} minWidth={768} />;

const mapDispatchToProps = dispatch => ({
  fetchAbandonedCarts: () => {
    dispatch(fetchAbandonedCarts());
  },
  updateAbandonedCartLeadInfo: (id,data) => {
    dispatch(updateAbandonedCartLeadInfo(id,data));
  },
  fetchCustomTimeAbandonedCart : (sDate,eDate) => {
    dispatch(fetchCustomTimeAbandonedCart(sDate,eDate));
  }
});

CenteredTabs = connect(mapStateToProps, mapDispatchToProps)(CenteredTabs);

export default withRouter(CenteredTabs);

